/**
 * This method test a string and return is value decripted if it's a base 64
 * else it must return the given string
 *
 * @param {*} string : String to test
 * @returns
 */
export const transformStringToIdIfIsBase64 = (string) => {
	const base64Regex = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/;

	if (base64Regex.test(string)) {
		return atob(string).split(':')[1];
	}
	return string;
  }
